import React from 'react'
import { useState } from 'react'
import {  useNavigate } from 'react-router-dom'
import { useStore } from '../../context/store.provider'
import { ROUTES_LINKS } from '../../routes/routes'
import { deleteData, updateDB } from '../user/GettingData/firebase'
import { priceFormatter } from './algoritem'
import './CrudProducts.css'

function CrudProducts() {
  const { filteredStoreProducts,outOfStock,setOutOfStock } = useStore()
const [confirm,setConfirm]= useState(false)

const outOfStockProducts =(id, category, imgUrl, price, productName,storePrice,quantity)=>{
  const identifier = id - 1;
  const newProduct = {
    "id": id,
    "category": category,
    "imgUrl": imgUrl,
    "price": price,
    "productName": productName,
    "storePrice": storePrice,
    "quantity":quantity?quantity:null,
    "outOfStock":true
  }
  updateDB(newProduct, identifier);
}
  const navigate = useNavigate();
  const onClickEdit = (id) => {    
    navigate(ROUTES_LINKS.TO_EDIT_PRODUCT.replace(':id', id));
  }
  
  const onClickDelete =() => {
    setConfirm(true)
  }
  const deleteProduct =(id)=>{
    const identifier = (id - 1).toString()
    deleteData(identifier)
  }
  const cancle =()=>{
    setConfirm(false)
  }
  const text = "האם אתה בטוח שברצונך למחוק"
  console.log(outOfStock)
  return (
    <div className='main-admin-site'>
      <div className='products-con'>
        {!filteredStoreProducts ? <h1>hello world</h1> : filteredStoreProducts.map(({ id, category, imgUrl, price, productName,storePrice,quantity }) =>
          <div className="container" key={id}>
            <button className='edit-product' onClick={() => outOfStockProducts(id, category, imgUrl, price, productName,storePrice,quantity)}>אין במלאי </button>
            <div className="card">
              <div className="imgBx">
                <img src={imgUrl} alt ="product" />
                <div className="contentBx">
                  <h2 className='text-card'>{productName}</h2>
                  <div className="size">
                    <h3 className='text-card'>{category}</h3>
                  </div>
                  <div className="color">
                    {/* <h3>{storePrice}</h3> */}
                    <h3 className='text-card'>{priceFormatter.format(price)}</h3>
                  </div>
                  <div>
                    <button className='edit-product' onClick={() => onClickEdit(id)}><i className="fa-solid fa-pen-to-square"></i></button>
                    <button className='delete-product' onClick={onClickDelete}><i className="fa-solid fa-trash"></i></button>
                  </div>
                  {confirm  && <div style={{backgroundColor:"white"}}>{text}<button onClick={() => deleteProduct(id)}>מחק</button><button onClick={cancle}>בטל</button></div>}
                </div>
              </div>
            </div>
          </div>
        )}
        
      </div>
    </div>
  )
}

export default CrudProducts